import { render } from "./BillingSettings.vue?vue&type=template&id=e24234a8"
import script from "./BillingSettings.vue?vue&type=script&lang=js"
export * from "./BillingSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__